import * as React from "react";
import { useLocation, useParams } from "react-router-dom";
import List from "./List";

function Board() {
  const location = useLocation();
  const sch = location.search;
  const params = new URLSearchParams(sch);
  const id = params.get("id");  
  return <><List id={id}/></>;
}

export default Board;
